export default __webpack_public_path__ + "static/media/settings.7df22468.png";